import Header from "./Header";
import NavBar from "./NavBar";
import { Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useEffect } from "react";
import { setActionLog } from "../utils/util";

const MainLayout = () => {
  const location = useLocation();
  const {isWorker} = useAuth();
  useEffect(()=>{
    setActionLog({eventType:'PAGE_VIEW',title:'화면진입'});
  },[location.pathname]);
  return (
    <div
      style={{ display: "flex", flexDirection: "column", height: "100vh", overflow: "hidden" }}
    >
      <div style={{ display: "flex", flex: 1, minHeight: 0, minWidth: 0 }}>
        {!isWorker && <NavBar />}
        <main style={{ flex: 1, minWidth: 0, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column" }}>
          <Header />
          <div
            style={{
              flex: 1,
              minHeight: 0,
              minWidth: 0,
              height: "calc(100vh - 60px)",
              maxWidth: "100%",
              padding: "1rem",
              overflow: "auto",
              boxSizing: "border-box",
            }}
          >
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );
};
export default MainLayout;
